'use strict';

function BrowserStorage(_sessionStorage) {
  this.sessionStorage = _sessionStorage;
}

BrowserStorage.prototype.set = function (_key, _value) {
  this.sessionStorage.setItem(_key, JSON.stringify(_value));
};

BrowserStorage.prototype.get = function (_key) {
  const item = this.sessionStorage.getItem(_key);
  if (item) {
    return JSON.parse(item);
  } else {
    return undefined;
  }
};

BrowserStorage.prototype.del = function (_key) {
  this.sessionStorage.removeItem(_key);
};

function MemoryStorage() {
  this.sessionStorage = {};
}

MemoryStorage.prototype.set = function (_key, _value) {
  this.sessionStorage[_key] = _value;
};

MemoryStorage.prototype.get = function (_key) {
  return this.sessionStorage[_key];
};

MemoryStorage.prototype.del = function (_key) {
  this.sessionStorage[_key] = undefined;
};

/**
 * @ngdoc factory
 * @name gestiondecriseApp.LocalStorage
 * @description
 * # LocalStorage
 * Factory in the gestiondecriseApp.
 */
angular.module('gestiondecriseApp').factory('localStorage', function ($window) {
  let storage;

  try {
    $window.sessionStorage.setItem('test', '');
    $window.sessionStorage.removeItem('test');
    storage = new BrowserStorage($window.sessionStorage);
  } catch (err) {
    storage = new MemoryStorage();
  }

  function setUrlLocation(location) {
    storage.set('locationUrl', location);
  }

  function setPrevUrlLocation(location) {
    storage.set('prevLocationUrl', location);
  }

  function setUrlParams(params) {
    storage.set('locationParams', params);
  }

  function getUrlLocation() {
    return storage.get('locationUrl');
  }

  function getPrevUrlLocation() {
    return storage.get('prevLocationUrl');
  }

  function getUrlParams() {
    return storage.get('locationParams');
  }

  function setOccDashboardLastDisplayTime(time) {
    storage.set('occDashboardLastDisplayTime', time);
  }

  function setEclDashboardLastDisplayTime(time) {
    storage.set('eclDashboardLastDisplayTime', time);
  }

  function setOpsDashboardLastDisplayTime(time) {
    storage.set('opsDashboardLastDisplayTime', time);
  }

  function setGocDashboardLastDisplayTime(time) {
    storage.set('gocDashboardLastDisplayTime', time);
  }

  function setErpDashboardLastDisplayTime(time) {
    storage.set('erpDashboardLastDisplayTime', time);
  }

  function setEclCrisisSelectedId(id) {
    storage.set('eclCrisisSelectedId', id);
  }

  function getEclCrisisSelectedId() {
    return storage.get('eclCrisisSelectedId');
  }

  return {
    setUrlLocation: setUrlLocation,
    setPrevUrlLocation: setPrevUrlLocation,
    setUrlParams: setUrlParams,
    getUrlLocation: getUrlLocation,
    getPrevUrlLocation: getPrevUrlLocation,
    getUrlParams: getUrlParams,
    setOccDashboardLastDisplayTime: setOccDashboardLastDisplayTime,
    setEclDashboardLastDisplayTime: setEclDashboardLastDisplayTime,
    setOpsDashboardLastDisplayTime: setOpsDashboardLastDisplayTime,
    setGocDashboardLastDisplayTime: setGocDashboardLastDisplayTime,
    setErpDashboardLastDisplayTime: setErpDashboardLastDisplayTime,
    setEclCrisisSelectedId: setEclCrisisSelectedId,
    getEclCrisisSelectedId: getEclCrisisSelectedId
  };
});
